
import React from 'react';
import { Typography } from "antd";
import { useIntl } from "react-intl";

const BookingLandingEmpty: React.FC = () => {
  const intl = useIntl();
  return (
    <div
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: 80,
          height: 80,
          borderRadius: "50%",
          background: "#001529",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          fontWeight: 600,
          fontSize: 24,
          marginBottom: 8,
        }}
      >
        BC
      </div>
      <Typography.Title level={3} style={{ margin: 0 }}>
        {intl.formatMessage({ id: "booking.landingEmpty.title" })}
      </Typography.Title>
      <Typography.Paragraph type="secondary" style={{ maxWidth: 420, margin: "0 auto" }}>
        {intl.formatMessage({ id: "booking.landingEmpty.description" })}
      </Typography.Paragraph>
    </div>
  );
}

export default BookingLandingEmpty